var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrength(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 36,
    viewBox: "0 0 43 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_952_13289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.853271,
    width: 41.6667,
    height: 35,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_952_13289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3007 29.5618C23.6981 27.3366 22.4302 25.5242 20.62 24.0758C18.2806 22.2069 15.6636 20.9739 12.5907 20.8611C10.9717 20.8021 9.40514 21.0764 7.93288 21.7429C6.22746 22.5171 5.04598 23.8117 4.2496 25.4626C3.31175 27.4084 3.07597 29.4874 3 32.0946C3.0393 32.4073 3.07597 32.8508 3.13361 33.3533H24.6386C24.7172 32.0715 24.6386 30.8077 24.3007 29.5618Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.092 21.8036L22.2516 11.9805L11.4929 0.853248L1.33328 10.6764L12.092 21.8036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0563 6.6924C12.644 6.72832 13.209 6.88846 13.6882 7.27458C14.8815 8.2324 15.7444 9.40274 16.1524 10.8185C16.6041 12.384 16.188 13.8057 15.1518 15.0793C14.6014 15.7558 13.8939 16.2526 13.0196 16.5505C12.1809 16.8348 11.4362 16.6492 10.7351 16.2182C9.31364 15.3442 8.34546 14.135 7.7189 12.6788C7.36757 11.8616 7.17329 11.0116 7.16681 10.1346C7.15548 8.48383 8.08642 7.35091 9.82525 6.96329C10.5263 6.80615 11.3099 6.6505 12.053 6.6939L12.0563 6.6924Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrength);
export default __webpack_public_path__ + "static/media/Strength.84186351519506d5c0496bb6983eccde.svg";
export { ForwardRef as ReactComponent };